<header class="header">
  <div class="sc-container header-content">
    <a routerLink="/" class="brand-link" aria-label="Square Control home"><app-brand-logo /></a>
    <nav class="desktop-nav" aria-label="Main navigation">
      <a routerLink="/players-and-parents" routerLinkActive="selected" ariaCurrentWhenActive="page">Players &amp; parents</a>
      <a routerLink="/club-owners-and-teachers" routerLinkActive="selected" ariaCurrentWhenActive="page">Club owners &amp; teachers</a>
      <a routerLink="/clubs" routerLinkActive="selected" ariaCurrentWhenActive="page">Find a club</a>
      @if (signedIn) {
        <a appButton routerLink="/dashboard">My workspace</a>
      } @else {
        <a routerLink="/login" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" ariaCurrentWhenActive="page">Sign in</a>
        <a appButton routerLink="/register" [queryParams]="{ returnUrl: '/clubs' }">Create account</a>
      }
    </nav>
    <button class="mobile-menu-button" type="button" appButton="secondary" (click)="openMenu()" aria-label="Open navigation" aria-haspopup="dialog">
      <app-icon name="menu" />
    </button>
  </div>
</header>
<app-modal #mobileMenu title="Menu" size="small">
  <nav class="mobile-nav" aria-label="Mobile navigation">
    <a appButton="quiet" routerLink="/" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" ariaCurrentWhenActive="page" (click)="closeMenu()">Home</a>
    <a appButton="quiet" routerLink="/players-and-parents" routerLinkActive="selected" ariaCurrentWhenActive="page" (click)="closeMenu()">Players &amp; parents</a>
    <a appButton="quiet" routerLink="/club-owners-and-teachers" routerLinkActive="selected" ariaCurrentWhenActive="page" (click)="closeMenu()">Club owners &amp; teachers</a>
    <a appButton="quiet" routerLink="/clubs" routerLinkActive="selected" ariaCurrentWhenActive="page" (click)="closeMenu()">Find a club</a>
    @if (signedIn) {
      <a appButton routerLink="/dashboard" (click)="closeMenu()">My workspace</a>
    } @else {
      <a appButton="secondary" routerLink="/login" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" ariaCurrentWhenActive="page" (click)="closeMenu()">Sign in</a>
      <a appButton routerLink="/register" [queryParams]="{ returnUrl: '/clubs' }" (click)="closeMenu()">Create account</a>
    }
  </nav>
</app-modal>
